$(document).ajaxError(function (event, jqxhr, settings, thrownError) {
   if (jqxhr.status === 401) {
        document.location.href = '/';
   }
});

$.fn.select2.defaults.set( "theme", "bootstrap4" );

$('.select2').each(function(index, el){
    let conf = $.extend({}, $(el).data('config'));
    $(el).select2(conf);
});

window.initComponents = function() {
    $('[data-toggle="popover"]').each((index, el) => {
        let conf = $.extend({
            "trigger": "hover",
            "container": "body",
            "placement": "left",
            "html": true
        }, $(el).data());

        $(el).popover('dispose')
        $(el).popover(conf);
    })

    $("[id^='tooltip']").tooltip('hide');
}

window.dt_options = {

	"initComplete" : function(settings, data){
        initComponents();
    },

    "drawComplete" : function(settings, data){
        initComponents();
    }
}


$(document).ready(function(){

    $('.counter').each(function () {
        var $this = $(this);
        jQuery({ Counter: 0 }).animate({ Counter: $this.text() }, {
            duration: 1000,
            easing: 'swing',
            step: function () {
                $this.text(Math.ceil(this.Counter));
            }
        });
    });

    initComponents();
});
